<div [ngClass]="['status-badge', 'status-badge--' + size, 'status-badge--' + status]">
  <img
    *ngIf="iconType && iconPath"
    [src]="iconPath"
    alt="{{ status }} icon"
    class="status-badge__icon"
  />
  <span class="status-badge__label">{{ label }}</span>
</div>
